import { render, staticRenderFns } from "./UserDetails_Section_AuthorStats.vue?vue&type=template&id=179048c3&scoped=true&"
import script from "./UserDetails_Section_AuthorStats.vue?vue&type=script&lang=js&"
export * from "./UserDetails_Section_AuthorStats.vue?vue&type=script&lang=js&"
import style0 from "./UserDetails_Section_AuthorStats.vue?vue&type=style&index=0&id=179048c3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "179048c3",
  null
  
)

export default component.exports